<template>
	<div class='row'>
		<div class='cell'>
			<a class='green' :href='`/profile/${value.public_user.pk}/`' v-if='value.public_user && value.public_user.pk'>
				{{value.name}}
				<div class='agent-icon agent-icon-md' v-if='value.public_user.type=="agent"'>
					<icon icon-name='agent'/>
				</div>
			</a>
			<p v-else>{{value.name}}</p>
		</div>
		<div class='cell'>
			<p>{{value.email}}</p>
		</div>
		<div class='cell'>
			<p>{{value.phone}}</p>
		</div>
		<div class='cell' v-if='!hideMarket'>
			<p>{{value.market.name}}, {{value.market.region?.name}}</p>
		</div>
		<div class='cell' v-if='!hideRecomended'>
			<a class='green' :href='`/profile/${value.recommended_by.id}/`'>{{value.recommended_by.name}}</a>
		</div>
	</div>
</template>

<script>
import icon from '__jsVueUI/icon.vue';
export default {
	name:       'Contact',
	components: {
		icon
	},
	props: {
		value: {
			type: Object
		},
		hideRecomended: {
			type:    Boolean,
			default: false
		},
		hideMarket: {
			type:    Boolean,
			default: false
		},
	}
};
</script>
